import { render, staticRenderFns } from "./TaskKanban.vue?vue&type=template&id=069fdf87&scoped=true"
import script from "./TaskKanban.vue?vue&type=script&lang=ts"
export * from "./TaskKanban.vue?vue&type=script&lang=ts"
import style0 from "./TaskKanban.vue?vue&type=style&index=0&id=069fdf87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069fdf87",
  null
  
)

export default component.exports